import {
  TIPO_VENDA_LIST,
  TIPO_VENDA_GET_BY_ID,
  TIPO_VENDA_CREATE,
  TIPO_VENDA_UPDATE,
  TIPO_VENDA_REMOVE
} from "../actions/tipoVenda";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = {};

const getters = {};

/** Toda chamada exibe a mensagem da API (campo msg do errorBody v4) via ERRORS_SHOW. */
const withErrors = (dispatch, request) =>
  new Promise((resolve, reject) => {
    request()
      .then(resp => resolve(resp.data))
      .catch(err => {
        dispatch(ERRORS_SHOW, err);
        reject(err);
      });
  });

const actions = {
  [TIPO_VENDA_LIST]: ({ dispatch, getters }) =>
    withErrors(dispatch, () => Api.v4.tipoVenda.list(getters.getFornecedorId)),
  [TIPO_VENDA_GET_BY_ID]: ({ dispatch, getters }, idtipovenda) =>
    withErrors(dispatch, () =>
      Api.v4.tipoVenda.getById(getters.getFornecedorId, idtipovenda)
    ),
  [TIPO_VENDA_CREATE]: ({ dispatch, getters }, payload) =>
    withErrors(dispatch, () =>
      Api.v4.tipoVenda.create(getters.getFornecedorId, payload)
    ),
  [TIPO_VENDA_UPDATE]: ({ dispatch, getters }, { idtipovenda, payload }) =>
    withErrors(dispatch, () =>
      Api.v4.tipoVenda.update(getters.getFornecedorId, idtipovenda, payload)
    ),
  [TIPO_VENDA_REMOVE]: ({ dispatch, getters }, idtipovenda) =>
    withErrors(dispatch, () =>
      Api.v4.tipoVenda.remove(getters.getFornecedorId, idtipovenda)
    )
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
